"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAskAnAgentListUrlCallback = void 0;
exports.getAskAnAgentListUrlCallback = function (url, n) {
    var pcs = url.split('?');
    var pnoStr = "?pno=" + n;
    return "" + pcs[0] + pnoStr;
};
